module.exports = __webpack_public_path__ + "img/img_merit_02.6a3ee000.svg";